import { render, staticRenderFns } from "./rutaDetalle.vue?vue&type=template&id=bc6c00ae"
import script from "./rutaDetalle.vue?vue&type=script&lang=js"
export * from "./rutaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports